module.exports = __webpack_public_path__ + "img/btn_menu_bidv.843d2890.svg";